var _filter, _circle, _text, _text2, _text3, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _polygon, _circle5, _g, _circle6, _line, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncipherxEnhanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyberGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00cccc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#009999",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "none",
    stroke: "url(#cyberGradient)",
    strokeWidth: 2,
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#00ffff",
    filter: "url(#glow)"
  }, "ENCIPHERX")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 105,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    fill: "#00cccc",
    opacity: 0.8
  }, "CYBERSECURITY")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 125,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 10,
    fill: "#009999",
    opacity: 0.7
  }, "v4.0")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 3,
    fill: "#00ffff",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 8,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 15,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20 20 L 30 20 L 30 30 L 20 30",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 20 L 180 20 L 180 30 L 170 30",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 170 L 30 170 L 30 180 L 20 180",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 170 L 180 170 L 180 180 L 170 180",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 160,40 160,100 100,130 40,100 40,40",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 70,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.6,
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 100 100",
    to: "360 100 100",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "satellite",
    transform: "translate(170, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -6,
    width: 24,
    height: 12,
    fill: "#111",
    stroke: "#00ffff",
    strokeWidth: 2,
    rx: 3,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -4,
    width: 10,
    height: 8,
    fill: "#222",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#222;#00ffff;#222",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -4,
    width: 10,
    height: 8,
    fill: "#222",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#222;#00ffff;#222",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -6,
    x2: 0,
    y2: -15,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 2,
    fill: "#00ffff",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2;3;2",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 6,
    ry: 4,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -2,
    width: 4,
    height: 4,
    fill: "#ff6600",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: -17,
    cy: 0,
    rx: 3,
    ry: 2,
    fill: "#ff9900",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "0.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "3;5;3",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "15s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.5;0.1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 100 100",
    to: "360 100 100",
    dur: "15s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 85,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 0.5,
    opacity: 0.1,
    strokeDasharray: "10,10"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 100 100",
    to: "360 100 100",
    dur: "30s",
    repeatCount: "indefinite"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 170,
    y2: 100,
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "1.5;3;1.5",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 1,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;2;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 100,
    r: 1,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;2;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 100,
    r: 1,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;2;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncipherxEnhanced);
export default __webpack_public_path__ + "static/media/encipherx-enhanced.6bb3eccdcd7297310b1ebde749fae658.svg";
export { ForwardRef as ReactComponent };